import * as React from "react";
import Box from "@mui/material/Box";
import { useState } from "react";
import Stepper from "./Stepper";
import { Nav } from "./Elements";
import { Grid } from "@mui/material";
import { getsteps, getCurrentStep } from "./stepperSlice";
import { useSelector } from "react-redux";
import CancelJobButton from "../CancelJobButton";
import InstallationAssistance from "../InstallationAssistance";
import { useParams } from "react-router-dom";
import { useGetJobCardByReferenceQuery } from "../../api/apiSlice";
import { useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useConnectionMonitor } from "../connectionsTest";
import SignalBanner from "../SignalBanner";


export default function NavbarStepper({ step, complete }) {
  const stepsGlobal = useSelector(getCurrentStep);
  const [currentStep, setCurrentStep] = useState(step ? step : stepsGlobal);
  const steps = useSelector(getsteps);
  const { job_card_reference_id } = useParams();
  const { data: job_card_data } = useGetJobCardByReferenceQuery(
    job_card_reference_id,
    { skip: !job_card_reference_id }
  );
  const dispatch = useDispatch();
  const isComplete = complete === true;

  const { isConnected } = useConnectionMonitor();
  const isSignalInsufficient = !isConnected;

  React.useEffect(() => {
    if (step) {
      setCurrentStep(step);
    } else {
      setCurrentStep(stepsGlobal);
    }
  }, [stepsGlobal, step]);

  const badgeStyle = {
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: isComplete ? "#22C55E" : "#FDB940",
    color: "#000",
    fontSize: "13px",
    fontWeight: 700,
    flexShrink: 0,
  };

  const stepTitleStyle = {
    color: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "Roboto, sans-serif",
    marginLeft: "8px",
  };

  const counterStyle = {
    color: "rgba(255,255,255,0.45)",
    fontSize: "13px",
    fontFamily: "Roboto, sans-serif",
    whiteSpace: "nowrap",
  };

  const rowStyle = {
    display: "flex",
    alignItems: "center",
  };

  return (
    <>
    <Box sx={{ mb: 15 }}>
      <Nav>
        <Grid container alignItems="center" sx={{ px: 1.5, py: 0.5 }}>
          {/* Left: step badge + title */}
          <Grid item xs={7} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {job_card_data?.install_state === "NEW" && <CancelJobButton />}
            {isComplete ? (
              <CheckCircleIcon sx={{ color: "#22C55E", fontSize: 28, flexShrink: 0 }} />
            ) : (
              <div style={badgeStyle}>{currentStep + 1}</div>
            )}
            <span style={stepTitleStyle}>
              <StepperHeading step={currentStep} steps={steps} isComplete={isComplete} />
            </span>
          </Grid>

          {/* Right: X / Y counter + assistance icon */}
          <Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1 }}>
            <span style={counterStyle}>
              {isComplete ? steps.length : currentStep + 1} / {steps.length}
            </span>
            <InstallationAssistance />
          </Grid>

          {/* Progress bar full width */}
          <Grid item xs={12}>
            <Stepper steps={steps} currentStep={currentStep} />
          </Grid>
        </Grid>
      </Nav>
    </Box>
    {isSignalInsufficient && <SignalBanner />}
    </>
  );
}

function StepperHeading({ step, steps, isComplete }) {
  if (isComplete) return "Complete";
  if (steps.length === 6) {
    // NEW install
    switch (step) {
      case 0: return "Installation Details";
      case 1: return "Scan QR";
      case 2: return "Before Photos";
      case 3: return "Install";
      case 4: return "Test Connection";
      case 5: return "After Photos";
      default: return "Details";
    }
  } else if (steps.length === 4) {
    // UN uninstall
    switch (step) {
      case 0: return "Scan QR";
      case 1: return "Before Photos";
      case 2: return "Uninstall";
      case 3: return "After Photos";
      default: return "Details";
    }
  } else if (steps.length === 8) {
    // RE replacement
    switch (step) {
      case 0: return "Scan QR";
      case 1: return "Before Photos";
      case 2: return "Uninstall";
      case 3: return "Scan QR";
      case 4: return "Installation Details";
      case 5: return "Install";
      case 6: return "Test Connection";
      case 7: return "After Photos";
      default: return "Details";
    }
  }
  return "Details";
}
